import { c as _c } from "react/compiler-runtime";
import { BLOGS_API } from 'modules/blogs/api/blog-api';
import { BlogPostsApiInterface, BlogPostsFilterInterface } from 'modules/blogs/types/blog-posts-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
interface UseBlogPostsInterface extends SwrPaginationInterface {
  id: string;
  filter: BlogPostsFilterInterface;
}
export function useBlogPosts(t0) {
  const $ = _c(15);
  const {
    id,
    pagination,
    limit,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.searchBy !== "" ? `&filter[searchBy]=${encodeURIComponent(filter.searchBy)}` : ""}${filter.isActive !== undefined ? `&filter[isActive]=${filter.isActive}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== id || $[3] !== limit || $[4] !== pagination || $[5] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${BLOGS_API}/${id}/posts/list?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${BLOGS_API}/${id}/posts/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        }
      }
      return null;
    };
    $[1] = filterApi;
    $[2] = id;
    $[3] = limit;
    $[4] = pagination;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: blogPosts,
    mutate: blogPostsMutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[7] !== filterApi || $[8] !== id || $[9] !== user) {
    t3 = () => {
      if (user) {
        return `${BLOGS_API}/${id}/posts/count?pagination[limit]${filterApi}`;
      }
      return null;
    };
    $[7] = filterApi;
    $[8] = id;
    $[9] = user;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    data: blogPostsCounter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[11] !== blogPosts || $[12] !== blogPostsCounter || $[13] !== blogPostsMutate) {
    t4 = {
      blogPosts,
      blogPostsMutate,
      blogPostsCounter
    };
    $[11] = blogPosts;
    $[12] = blogPostsCounter;
    $[13] = blogPostsMutate;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}